import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { INeighborhoodDetails } from '@api'
import { NeighborhoodDetailsFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

const mutation = gql`
  mutation CreateNeighborhoodMutation($input: CreateNeighborhoodInput!) {
    createNeighborhood(input: $input) {
      neighborhood {
        ...NeighborhoodDetailsFragment
      }
    }
  }
  ${NeighborhoodDetailsFragment}
`

interface IPayload {
  createNeighborhood: {
    neighborhood: INeighborhoodDetails
  }
}

const mutateHandler = handleFetchResult<IPayload, INeighborhoodDetails>({
  handler: (data) => data.createNeighborhood.neighborhood,
  name: 'Create Neighborhood',
})

export default async function addNeighborhood({
  name,
  floorId,
  capacity,
}: {
  name: string
  floorId: string
  capacity?: string
}): Promise<INeighborhoodDetails> {
  const input: { name: string; floorPlanId: string; maxEmployees?: number } = {
    name,
    floorPlanId: floorId,
  }

  if (capacity) {
    input.maxEmployees = Number(capacity)
  }

  return client.gql
    .mutate({
      mutation,
      variables: { input },
    })
    .then(mutateHandler)
}
